import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NotificationService } from '@clean-code/notifications/domain';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBell, faBellOn } from '@fortawesome/pro-solid-svg-icons';
import { HubConnectionState } from '@microsoft/signalr';

@Component({
    selector: 'notifications-notification-bell',
    templateUrl: './notification-bell.component.html',
    styleUrl: './notification-bell.component.scss',
    imports: [CommonModule, FontAwesomeModule]
})
export class NotificationBellComponent {
  private notificationService = inject(NotificationService);
  public unreadCount = this.notificationService.unreadCount;
  public connectionState = this.notificationService.connectionState;

  public faBell = faBell;
  public faBellOn = faBellOn;
  public connectedState = HubConnectionState.Connected;

  public isLowCount(count: number): boolean {
    return count > 0 && count < 5;
  }

  public getAnimationClass(count: number): string {
    if (count === 0) return '';
    return this.isLowCount(count) ? 'animate-5' : 'animate-20';
  }
}
